import React from 'react';
import { X } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

export interface FilterChip {
    key: string;
    label: string;
    onRemove: () => void;
}

interface FilterChipsBarProps {
    chips: FilterChip[];
    onClearAll: () => void;
    className?: string;
}

/** Removable chip row for applied advanced filters, plus a "Clear all" link.
 * Renders nothing when there are no chips — callers can mount it unconditionally. */
export const FilterChipsBar: React.FC<FilterChipsBarProps> = ({ chips, onClearAll, className }) => {
    if (chips.length === 0) return null;
    return (
        <div className={`flex flex-wrap items-center gap-2 border-b px-4 py-3 sm:px-6 ${className ?? ''}`}>
            {chips.map((chip) => (
                <Badge key={chip.key} variant="secondary" className="gap-1 pr-1 font-normal">
                    {chip.label}
                    <button
                        type="button"
                        onClick={chip.onRemove}
                        className="cursor-pointer rounded-full p-0.5 hover:bg-muted-foreground/20"
                        aria-label={`Remove filter: ${chip.label}`}
                    >
                        <X className="h-3 w-3" />
                    </button>
                </Badge>
            ))}
            <Button
                type="button"
                variant="ghost"
                size="sm"
                className="h-6 cursor-pointer px-2 text-xs text-muted-foreground"
                onClick={onClearAll}
            >
                Clear all
            </Button>
        </div>
    );
};
